import { List, Map, OrderedMap, is as immutableEqual } from 'immutable'

const terminalCharData = Map({ style: List() })

export const STYLE_MARKUP = OrderedMap([
  ['BOLD', Map({ start: '<b>', end: '</b>' })],
  ['ITALIC', Map({ start: '<i>', end: '</i>' })],
  ['UNDERLINE', Map({ start: '<u>', end: '</u>' })],
  ['CODE', Map({ start: '<code>', end: '</code>' })],
  ['SUBSCRIPT', Map({ start: '<sub>', end: '</sub>' })],
  ['SUPERSCRIPT', Map({ start: '<sup>', end: '</sup>' })]
])

export const BLOCK_MARKUP = Map({ start: '<p>', end: '</p>', join: '' })

export const BLOCK_TYPES = Map({
  'header-one': Map({ start: '<h1>', end: '</h1>' }),
  'header-two': Map({ start: '<h2>', end: '</h2>' }),
  'header-three': Map({ start: '<h3>', end: '</h3>' }),
  blockquote: Map({ start: '<blockquote>', end: '</blockquote>' }),
  'code-block': Map({ start: '<pre><code>', end: '</code></pre>' }),
  'ordered-list-item': Map({ start: '<ol><li>', end: '</li></ol>' }),
  'unordered-list-item': Map({ start: '<ul><li>', end: '</li></ul>' })
})

export const FILTER_CHARS = Map({
  '<': '&lt;',
  '>': '&gt;',
  '&': '&amp;'
})

export default function convertBlockMapToHTML({
  styleMarkup = STYLE_MARKUP,
  blockMarkup = BLOCK_MARKUP,
  blockTypes = BLOCK_TYPES,
  filterChars = FILTER_CHARS
} = {}) {
  return blockMap =>
    blockMap
      .map(block => {
        const text = block.get('text') || ''
        const characterList = block.get('characterList') || List(Array.from({ length: text.length }))
        const blockType = block.get('type')
        const blockStart = blockTypes.has(blockType) ? blockTypes.get(blockType).get('start') : ''
        const blockEnd = blockTypes.has(blockType) ? blockTypes.get(blockType).get('end') : ''
        return (
          blockStart +
          characterList
            .push(terminalCharData)
            .reduce(
              ({ html, lastStyle }, charData, index) => {
                let addHTML = (text[index] && (filterChars.get(text[index]) || text[index])) || ''
                const style = charData.get('style')
                if (!immutableEqual(style, lastStyle)) {
                  const addStyles = style // .filter(x => !lastStyle.includes(x))
                  const removeStyles = lastStyle //.filter(x => !style.includes(x))
                  if (addStyles.size) {
                    addHTML =
                      styleMarkup.reduce(
                        (tags, markup, style) => (addStyles.has(style) ? tags + (markup.get('start') || '') : tags),
                        ''
                      ) + addHTML
                  }
                  if (removeStyles.size) {
                    addHTML =
                      styleMarkup.reduceRight(
                        (tags, markup, style) => (removeStyles.has(style) ? tags + (markup.get('end') || '') : tags),
                        ''
                      ) + addHTML
                  }
                }
                return {
                  html: html + addHTML,
                  lastStyle: style
                }
              },
              {
                html: blockMarkup.get('start') || '',
                lastStyle: List()
              }
            )
            .html.replace(/\n/g, '<br>') +
          (blockMarkup.get('end') || '') +
          blockEnd
        )
      })
      .join(blockMarkup.get('join') || '')
}
